import { setSettings } from "../../Redux/DownloadSlice/downloadSlice";
import { sendGetCallToSever, sendPostCallToSever } from "../Axios/Axios";

const SaveSettings = (downloadState, uploaded) => () => {
  let preserve_format, format, Preserveresolution, resolution;
  if (downloadState.Format === 0) {
    preserve_format = true;
    format = "";
  } else {
    preserve_format = false;
    format = downloadState.Format;
  }
  if (downloadState.Resolution === 0) {
    Preserveresolution = true;
    resolution = "";
  } else {
    Preserveresolution = false;
    resolution = parseInt(downloadState.Resolution).toString();
  }
  var payload = {
    preserve_format: preserve_format,
    format: format,
    maintain_resolution: Preserveresolution,
    resolution: resolution,
    quality: downloadState.Quality,
  };

  // SEND CALL TO SERVER TO LOGIN FROM PUNCH
  return sendPostCallToSever(payload, "setting").then(() => {
    uploaded();
  });
};
const GetSettings = () => (dispatch) => {
  return sendGetCallToSever("setting").then((result) => {
    var data = result.data;
    let Format, Resolution, Quality;
    if (data.preserve_format === true) {
      Format = 0;
    } else {
      Format = data.format;
    }
    if (data.maintain_resolution === true) {
      Resolution = 0;
    } else {
      Resolution = parseInt(data.resolution);
    }
    Quality = data.quality;
    if (result.data.length) {
      dispatch(
        setSettings({
          Format,
          Resolution,
          Quality,
          Found: true,
        })
      );
    } else
      dispatch(
        setSettings({
          Format: 0,
          Resolution: 0,
          Quality,
          Found: false,
        })
      );
  });
};

export { SaveSettings, GetSettings };
